export const AI_REASONING_PERMISSION_KEY = 'aiReasoningVisibility'

const DEFAULT_ALLOWED_ROLES = ['ADMIN', 'MANAGER'] as const

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

/**
 * Resolves the role-level toggle controlling AI reasoning visibility — the
 * agent's thinking steps, preflight/escalation notes, prompts, and tool
 * arguments surfaced in the Pulse trace overlay, the inbox AI trace sidebar,
 * and the proposed-reply reasoning preview.
 *
 * An explicit role/custom-role value wins over the built-in defaults. Custom
 * roles (Ops/Maintenance and similar field roles) are hidden by default;
 * PROD-9072.
 */
export function canViewAiReasoning(permissions: unknown, role: string): boolean {
  const config = isRecord(permissions) ? permissions : null
  const explicitValue = config?.[AI_REASONING_PERMISSION_KEY]
  if (typeof explicitValue === 'boolean') {
    return explicitValue
  }

  return DEFAULT_ALLOWED_ROLES.some((allowedRole) => allowedRole === role)
}
